import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('core', ['companyName']),
    seoTitle() {
      let title = 'Wir kaufen Ihr Auto! Kostenlose Online-Bewertung'

      return this.replaceTags(title)
    },
    seoDescription() {
      let description = 'Wir kaufen Ihr Auto! Kostenlose Online-Bewertung'

      return this.replaceTags(description)
    }
  },
  methods: {
    replaceTags: function(text) {
      text = text.replace('<companyName>', this.companyName)

      return text
    }
  }
}
